import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';

import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useRef } from 'react';
import _isEqual from 'lodash/isEqual';
// Inside your component


const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps



function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const coupons = [
    { id: 1, code: '123', workshop_id: 6 },
    { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
    { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
    { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
    { id: 5, code: '963', workshop_id: 7 },
    { id: 6, code: '258', workshop_id: 25 },
    { id: 7, code: '147', workshop_id: 26 },
];

const rows = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, 'fixFDMJIK', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),
].map((row, index) => {
    const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
    const discount = coupon ? coupon.discount : 0;
    return { ...row, discount };
}).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));



const EditWorkShopParticpant = (props) => {
    const id = props.match.params.id;
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid');
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState('');
    const [selectedWorkshops, setSelectedWorkshops] = useState([]);
    const [selectedWorkshopAmounts, setSelectedWorkshopAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const tableCellRef = useRef(null);
    const [isCopied, setIsCopied] = useState(false);
    const [copiedStates, setCopiedStates] = useState({});
    const workshop_particpant_email = localStorage.getItem('workshop_particpant_email');
    const [addWorkShopParticpant, setAddWorkShopParticpant] = React.useState({
        workShop_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        particent_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        // password: "",
        // phone: "",
        // date: "",
        // address: "",
        // details: "",
        error_list: [],
    });
    const [editWorkShopParticpant, setEditWorkShopParticpant] = React.useState({

        category_amount: "",
        is_active: "",
        name_title: "",
        particent_address: "",
        particent_city: "",
        particent_country: "",
        particent_email: "",
        particent_gender: "",
        particent_name: "",
        particent_phone_number: "",
        particent_profession: "",
        particent_saudi_council_no: "",
        particent_workshop_categoy_id: "",
        password: "",
        error_list: [],
    });
    const [editWorkShopParticpantWorkshops, setEditWorkShopParticpantWorkshops] = React.useState({
        categoy_id: "",
        workshop_amount: "",
        workshop_code: "",
        workshop_discount: "",
        workshop_id: "",
        workshop_name: "",
        workshop_participant_id: "",
        workshop_type: "",
        workshop_coupon:"",
    });
    useEffect(() => {
        axios.get(`api/workshop-participant-edit/${id}`)
            .then(res => {
                if (res.status === 200) {
                    const participantData = res.data.data.participant;
                    const participantworkshopsData = res.data.data.workshops;
                   
                    setEditWorkShopParticpant(participantData);
                    setNameTitle(participantData.name_title);
                    setGender(participantData.particent_gender);
                    setCountry(participantData.particent_country);
                    setEditWorkShopParticpantWorkshops(participantworkshopsData.map(workshop => ({
                        categoy_id: workshop.categoy_id,
                        workshop_amount: workshop.workshop_amount,
                        workshop_code: workshop.workshop_code,
                        workshop_discount: workshop.workshop_discount,
                        workshop_id: workshop.workshop_id,
                        workshop_name: workshop.workshop_name,
                        workshop_participant_id: workshop.workshop_participant_id,
                        workshop_type: workshop.workshop_type,
                        workshop_coupon: workshop.workshop.workshop_coupon 
                    })));


                    const selectedRegistrationType = participantData.particent_workshop_categoy_id;

                    axios.get(`api/workshop-category-front-single/${selectedRegistrationType}`)
                        .then((response) => {
                            if (response.status === 200) {
                                const singleWorkShopData = response.data.swsd;
                                setSingleWorkShopCategory(singleWorkShopData);

                                // Update the state with the selected registration type
                                // Update the state with the selected registration type
                                setEditWorkShopParticpant(prevState => ({
                                    ...prevState,
                                    particent_workshop_categoy_id: selectedRegistrationType,
                                }));
                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        })


                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch(error => {
                console.error('Error fetching participant data:', error);
                // Handle error as needed
            });
    }, [id]);


    useEffect(() => {
        axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.workshopCategories;
                setWorkShopCategoryData(wcategoryData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    useEffect(() => {
        axios.get(`api/workshop-participant-used-coupeona?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;
                setWorkshopUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
console.log("singleWorkShopCategory" ,singleWorkShopCategory)

    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;
    console.log("marYam khan", selectedRegistrationType)
        // Trigger API request with the selectedRegistrationType
        axios.get(`api/workshop-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleWorkShopData = res.data.swsd;
                    setSingleWorkShopCategory(singleWorkShopData);

                    // Update the state with the selected registration type
                    setEditWorkShopParticpant(prevState => ({
                        ...prevState,
                        particent_workshop_categoy_id: selectedRegistrationType,
                    }));
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });
    };

    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop


    const handleCouponCodeChange = (workshopId, enteredCode) => {
        //console.log(`Updating coupon code for workshop ${workshopId} to ${enteredCode}`);
        setInputValues({ ...inputValues, [workshopId]: enteredCode });
    };


    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});

    useEffect(() => {
        axios.get(`api/workshop-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.workshopCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };


    const [colorMap, setColorMap] = useState({});



    //     const handleCheckboxChange = (event, workshop, workshop_amount) => {
    //   const { id, workshop_url, workshop_date, workshop_start_time, workshop_end_time, workshop_code, workshop_name, workshop_coupon } = workshop;

    //   // Check if the workshop is already selected
    //   const isAlreadySelected = editWorkShopParticpantWorkshops.some(
    //     (selectedWorkshop) => selectedWorkshop.workshop_id === id
    //   );

    //   if (event.target.checked && !isAlreadySelected) {

    //     setEditWorkShopParticpantWorkshops([...editWorkShopParticpantWorkshops, workshop]);
    //     setSelectedWorkshopAmounts([...editWorkShopParticpantWorkshops, { id, workshop_code, workshop_amount, workshop_name, workshop_coupon }]);

    //     const uniqueColor = getColorForFields(workshop_url, workshop_date, workshop_start_time);

    //     setEditWorkShopParticpantWorkshops((prevWorkshops) => [
    //       ...prevWorkshops,
    //       {
    //         categoy_id: workshop.categoy_id,
    //         workshop_amount,
    //         workshop_code,
    //         workshop_discount: workshop.workshop_discount,
    //         workshop_id: workshop.id,
    //         workshop_name,
    //         workshop_participant_id: workshop.workshop_participant_id,
    //         workshop_type: workshop.workshop_type,
    //       },
    //     ]);

    //     // Update the color map with the unique color for the specific row values
    //     setColorMap((prevColorMap) => ({
    //       ...prevColorMap,
    //       [`${workshop_url}-${workshop_date}-${workshop_start_time}`]: uniqueColor,
    //     }));
    //   } else if (!event.target.checked && isAlreadySelected) {
    //     setEditWorkShopParticpantWorkshops((prevWorkshops) =>
    //       prevWorkshops.filter((w) => w.workshop_id !== id)
    //     );

    //     // Clear the color map entry when the row is unchecked
    //     setColorMap((prevColorMap) => {
    //       const newColorMap = { ...prevColorMap };
    //       delete newColorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
    //       return newColorMap;
    //     });
    //   }
    // };


    const handleCheckboxChange = (event, workshop, workshop_amount) => {

        // Check if the workshop object is valid
        if (!workshop || typeof workshop !== 'object') {
            console.error('Invalid workshop object:', workshop);
            return;
        }

        const { id, workshop_url, workshop_date, workshop_start_time, workshop_code, workshop_name, workshop_coupon } = workshop;


        //     const { id, workshop_url, workshop_date, workshop_start_time, workshop_code, workshop_name, workshop_coupon } = workshop;
        // console.log("workshops", workshop)  
        // Check if the workshop is already selected
        const isAlreadySelected = editWorkShopParticpantWorkshops.some(
            (selectedWorkshop) => selectedWorkshop.workshop_id === id
        );

        // Disable all checkboxes if the current one is checked
        const updatedWorkshops = editWorkShopParticpantWorkshops.map((selectedWorkshop) => ({
            ...selectedWorkshop,
            isDisabled: event.target.checked,
        }));

        // If the checkbox is checked and the workshop is not already selected
        if (event.target.checked && !isAlreadySelected) {
            // Generate a unique color for the row based on specific fields
            const uniqueColor = getColorForFields(workshop_url, workshop_date, workshop_start_time);

            setEditWorkShopParticpantWorkshops((prevWorkshops) => [
                ...prevWorkshops,
                {
                    categoy_id: workshop.categoy_id,
                    workshop_amount,
                    workshop_code,
                    workshop_discount: workshop.workshop_discount,
                    workshop_id: workshop.id,
                    workshop_name,
                    workshop_participant_id: workshop.workshop_participant_id,
                    workshop_type: workshop.workshop_type,
                    workshop_type: workshop.workshop_type,
                    workshop_coupon: workshop.workshop_coupon,
                    isDisabled: false, // Enable the current workshop checkbox
                },
            ]);

            setSelectedWorkshopAmounts([...editWorkShopParticpantWorkshops, { id, workshop_code, workshop_amount, workshop_name, workshop_coupon }]);

            // Update the color map with the unique color for the specific row values
            setColorMap((prevColorMap) => ({
                ...prevColorMap,
                [`${workshop_url}-${workshop_date}-${workshop_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            // If the checkbox is unchecked and the workshop is already selected
            setEditWorkShopParticpantWorkshops((prevWorkshops) =>
                updatedWorkshops.filter((w) => w.workshop_id !== id)
            );
            setSelectedWorkshopAmounts(selectedWorkshopAmounts.filter((item) => item.id !== id));
            // Clear the color map entry when the row is unchecked
            setColorMap((prevColorMap) => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
                return newColorMap;
            });
        } else {
            // If the checkbox is unchecked and the workshop is not already selected
            setEditWorkShopParticpantWorkshops(updatedWorkshops);
        }



    };



//     useEffect(() => {
//         if (Array.isArray(editWorkShopParticpantWorkshops)) {
//             setSelectedWorkshopAmounts((prevWorkshops) =>
//                 editWorkShopParticpantWorkshops.map((workshop) => ({
//                     id: workshop.workshop_id,
//                     workshop_code: workshop.workshop_code,
//                     workshop_amount: workshop.workshop_amount,
//                     workshop_name: workshop.workshop_name,
//                     workshop_coupon: workshop.workshop_coupon,
//                 }))
//             );
//         }
//     }, [editWorkShopParticpantWorkshops.workshop]);
// console.log("editWorkShopParticpantWorkshops",editWorkShopParticpantWorkshops)
// console.log("selectedWorkshopAmounts",selectedWorkshopAmounts)


useEffect(() => {
    if (!Array.isArray(editWorkShopParticpantWorkshops)) return;

    for (const workshop of editWorkShopParticpantWorkshops) {
        if (!_isEqual(workshop, selectedWorkshopAmounts.find(({ id }) => id === workshop.workshop_id))) {
            setSelectedWorkshopAmounts(prevWorkshops =>
                editWorkShopParticpantWorkshops.map(workshop => ({
                    id: workshop.workshop_id,
                    workshop_code: workshop.workshop_code,
                    workshop_amount: workshop.workshop_amount,
                    workshop_name: workshop.workshop_name,
                    workshop_coupon: workshop.workshop_coupon,
                }))
            );
            break;
        }
    }
}, [editWorkShopParticpantWorkshops]);



    const isCheckboxDisabled = (workshop) => {
        const { id, workshop_url, workshop_date, workshop_start_time, workshop_end_time } = workshop;

        // Check if another workshop with the same values is already selected
        const isDisabled = selectedWorkshops.some(
            (selectedWorkshop) =>
                selectedWorkshop.workshop_url === workshop_url &&
                selectedWorkshop.workshop_date === workshop_date &&
                selectedWorkshop.workshop_start_time === workshop_start_time &&
                selectedWorkshop.workshop_end_time === workshop_end_time &&
                selectedWorkshop.id !== id
        );

        // Check if there's a color assigned for the specific row values and use it
        const color = colorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];

        return { isDisabled, color };
    };


    // Function to generate a unique color based on specific fields
    const getColorForFields = (url, date, startTime) => {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };

    useEffect(() => {

        Object.keys(discountMessages).forEach(workshopId => {
            const message = discountMessages[workshopId];

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);

    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    useEffect(() => {
        Object.keys(usedCouponMessage).forEach(workshopId => {
            const message = usedCouponMessage[workshopId];

        });
    }, [usedCouponMessage]);

    useEffect(() => {
        const newTotalAmount = selectedWorkshopAmounts.reduce((acc, workshop) => {
            
             //acc function is is get one by one and sum 
             //const numbers = [1, 2, 3, 4, 5];
             // Output: 15 (1 + 2 + 3 + 4 + 5)

            let discount = 0;
            const singleWorkshopAmount = Number(workshop.workshop_amount);

            let matchingCoupon = null;

            if (Array.isArray(couponCodes)) {
                // Remove the 'const' keyword here
                matchingCoupon = couponCodes.find(couponValue => inputValues[workshop.id] === couponValue.coupon_code);
                // Use matchingCoupon as needed
            }

            const useCoupon = workshopUsedCoupeon.filter(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            const useCouponCheck = workshopUsedCoupeon.find(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {

                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.workshop_participant_id
                        if (particpent_id == getPArticipentId) {
                            discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                        }
                        else if (useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                    }
                    else {
                        discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                    }
                }
                else if (matchingCoupon.coupon_amout_type === "fixed" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {
                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.workshop_participant_id
                        if (particpent_id == getPArticipentId) {
                            discount = matchingCoupon.coupon_amout_value;
                        }
                        else if (useCoupon && useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));

                        }
                    }
                    else {
                        discount = matchingCoupon.coupon_amout_value;
                    }
                }


                if (!isNaN(singleWorkshopAmount) && discount > 0) {

                    const message = `Discount applied for workshop ${workshop.id}. Coupon Code: ${inputValues[workshop.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [workshop.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [workshop.id]: true }));

                }
            }

            return acc + (singleWorkshopAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedWorkshopAmounts, couponCodes, inputValues]);

 



    const toggleCouponInput = (workshopId) => {
        setShowCouponInputs((prevState) => ({
            ...prevState,
            [workshopId]: !prevState[workshopId],
        }));
    };

    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setEditWorkShopParticpant({ ...editWorkShopParticpant, [e.target.name]: e.target.value });


    }

    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    // const handleChange = (event) => {

    //     setGender(event.target.value);
    //     localStorage.setItem(event.target.value);
    // };
    const handleChange = (event) => {
        setGender(event.target.value);

    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };



   
    const { error_list } = addWorkShopParticpant;
    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentBank = "paymentBank";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.particent_saudi_council_no,
            participant_name: editWorkShopParticpant.particent_name,
            participant_email: editWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.particent_phone_number,
            participant_profession: editWorkShopParticpant.particent_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.particent_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentBank,
            //editWorkShopParticpantWorkshops


        };

       

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-update/${id}`, data, config).then(res => {
                //setLoading(false);
                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    history.push('/admin/workshop/manage-particpant');
                    //history.push(`/workshop/thank-you/${id}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
          setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
 };




 const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    color_code: "",
    color_code_two: "",
    color_code_three: "",
    call_emergency: "",
    send_email: "",
    event_place: "",
    facebook_link: "",
    Instagram_link: "",
    linkedin_link: "",
    twitter_link: "",
    abstractFooterImage: "",
    abstractBannerImage: "",
    abstractSponserLogos: "",
    error_list: [],
});
React.useEffect(() => {
    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
        if (res.status === 200) {
            const getHomePageData = res.data.HomePageSetup;
            setAbstractHomeSetup(getHomePageData);
        }
    })

}, [eventid]);



let backGroundButtonByEvent = "";
if (eventid) {
    backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
}
else {
    backGroundButtonByEvent = '#145348'; // Default background color
}
//backgroundColor: backGroundButtonByEvent,





    const renderSelectedWorkshopInfo = () => {
        return (
            <div>


                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>WorkShop Code</TableCell>
                                <TableCell>Used Coupons</TableCell>
                                <TableCell></TableCell>
                                <TableCell>WorkShop Name</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">Workshop Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {selectedWorkshopAmounts && selectedWorkshopAmounts.map((selectedWorkshop, index) => {
                                const partiticipant_id = id;
                                const workshopId = selectedWorkshop.id;
                                const hasCoupon = workshopUsedCoupeon.some(couponsVal => selectedWorkshop.id === couponsVal.workshop_id);
                                const foundCoupon = workshopUsedCoupeon.find(couponsVal => partiticipant_id == couponsVal.workshop_participant_id && selectedWorkshop.id === couponsVal.workshop_id);
                                const couponCode = hasCoupon ? (foundCoupon ? foundCoupon.coupon_code : '') : '';

                                return (
                                    <TableRow key={selectedWorkshop.id}>
                                        <TableCell>{selectedWorkshop.workshop_code} </TableCell>
                                        {
                                            couponCode !== "" ? (
                                                <>
                                                    <TableCell onClick={() => copyCoupon(couponCode)} style={{ cursor: 'pointer' }}>{couponCode}</TableCell>
                                                    <TableCell>{copiedStates[couponCode] && <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1rem' }}>Copied!</span>}</TableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell>No Coupon</TableCell>
                                                    <TableCell></TableCell>
                                                </>
                                            )
                                        }

                                        <TableCell>{selectedWorkshop.workshop_name}</TableCell>
                                        <TableCell>
                                            {selectedWorkshop.workshop_coupon === 1 && (
                                                <Checkbox
                                                    checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                    onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (
                                                <Input
                                                    type="text"
                                                    placeholder="Your Coupon Code"
                                                    value={inputValues[selectedWorkshop.id] || ""}
                                                    onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                />
                                            )}
                                            {discountMessages[selectedWorkshop.id] && (
                                                <div>
                                                    <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                </div>
                                            )}
                                            {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                <div>
                                                    <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                </div>
                                            )}
                                        </TableCell>
                                        <TableCell align="right">{selectedWorkshop.workshop_amount}</TableCell>
                                    </TableRow>
                                );
                            })}



                            <TableRow>
                                <TableCell colSpan={7} align="right" style={{ fontWeight: 'bold' }}> Amount: {totalAmount} </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box noValidate sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {/* <Button
                        onClick={handleSubmitBank}
                        variant="contained"
                        sx={{ mt: 3, mb: 2, backgroundColor: '#145348' }}
                    >
                        Update Participant 
                    </Button> */}
                    <Button
                        onClick={handleSubmitBank}
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2,
                            ml: 4,
                            mr: 4,
                            backgroundColor: backGroundButtonByEvent,
                            cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                            opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                        }}
                        disabled={loading} // Disable the button when loading
                    >
                        {loading ? 'Loading...' : '  Update Participant '}
                    </Button>


                </Box>

            </div>
        );
    };

    return (
        <Container>
            <Typography
                component="h1"
                variant="h5"
                sx={{
                    margin: '5%',
                    width: '60vw',
                    marginLeft: '10%',
                    textAlign: 'center', // Center the text
                }}>
                WorkShop Participant Details
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Grid>
                <Grid item xs={12}>
                    <div>
                        {activeStep === steps.length ? (
                            <div >

                                <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                    <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                        <h4 sx={{ m: 2, color: '#000000' }} >

                                        </h4>




                                        {error_list && Object.keys(error_list).map(fieldName => (
                                            <div key={fieldName}>
                                                {/* <span style={{ color: 'red' }}>{fieldName}: </span> */}
                                                {error_list[fieldName].map((error, index) => (
                                                    <span key={index} style={{ color: 'red' }}>{error}</span>
                                                ))}
                                            </div>
                                        ))}


                                        <Card sx={{ width: '60vw', float: 'center' }} >
                                            <CardContent >
                                                <Typography component="h1" variant="h5" sx={{
                                                    textAlign: 'center', // Center the text
                                                }}>
                                                    Check Out

                                                </Typography>
                                                <Box component="form" noValidate sx={{ mt: 3 }}>


                                                    {renderSelectedWorkshopInfo()}




                                                </Box>
                                                <Grid container justifyContent="space-between">
                                                    <Button
                                                        //disabled={activeStep === 0}
                                                        disabled={true}
                                                        onClick={handleBack}
                                                        sx={{ mt: 5 }}>
                                                        Back
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        // onClick={handleNext}
                                                        onClick={handleBack}
                                                        sx={{ mt: 5,backgroundColor: backGroundButtonByEvent, }}
                                                    >
                                                        {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                                                    </Button>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {/* <Typography>{steps[activeStep]}</Typography> */}
                                {/* Render your form for each step */}
                                {activeStep === 0 && (
                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                            <h4 sx={{ m: 2, color: '#000000' }} >

                                                <Button sx={{
                                                    float: 'right',
                                                    marginTop: '2%',
                                                    backgroundColor: backGroundButtonByEvent,
                                                    ":hover": {
                                                        color: "white"
                                                    }
                                                }}
                                                    color='success'
                                                    size='small'
                                                    variant='contained'
                                                    component={Link}  // Use the Link component here
                                                    to="/admin/workshop/manage-particpant" >
                                                    Back
                                                </Button>
                                            </h4>
                                            <Card sx={{ width: '60vw', float: 'center' }} >
                                                <CardContent >
                                                    {/* <Typography component="h1" variant="h5">
                                                        Add WorkShop Participant
                                                    </Typography> */}
                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>

                                                            <Grid item xs={12} lg={6}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                                    <Select
                                                                        value={nameTitle}
                                                                        onChange={handleNameTitle}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Action"
                                                                    >
                                                                        <MenuItem value={'Mr'}>Mr</MenuItem>
                                                                        <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                                                        <MenuItem value={'Ms'}>Ms</MenuItem>
                                                                        <MenuItem value={'Dr'}>Dr</MenuItem>
                                                                        <MenuItem value={'Prof'}>Prof</MenuItem>
                                                                        <MenuItem value={'Eng'}>Eng</MenuItem>
                                                                        <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                                                    </Select>
                                                                    <FormHelperText>{addWorkShopParticpant.error_list.name_title}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>


                                                            <Grid item xs={6} >
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth
                                                                    label="Name"
                                                                    autoFocus
                                                                    name='particent_name' onChange={handleInput}
                                                                    value={editWorkShopParticpant?.particent_name || ""}
                                                                    helperText={addWorkShopParticpant?.error_list.participant_name} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    label="Saudi Council No"
                                                                    type="text"
                                                                    name='particent_saudi_council_no'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.particent_saudi_council_no || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.particent_saudi_council_no || ""}
                                                                />
                                                                <span style={{ color: 'red', textAlign: 'center' }}>
                                                                    If you don't have, just type 0000
                                                                </span>
                                                            </Grid>

                                                            <Grid item xs={12} lg={6}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                                                                    <Select

                                                                        value={editWorkShopParticpant?.particent_workshop_categoy_id || ""}
                                                                        // onChange={handleWorkShopCategory}
                                                                        onChange={handleregistration}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Workshop Category" >
                                                                        {
                                                                            workshopCategoryData && workshopCategoryData.map((val, index) => {
                                                                                return (
                                                                                    <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                                                                                )
                                                                            })
                                                                        }



                                                                    </Select>

                                                                    <FormHelperText>{addWorkShopParticpant.error_list.participant_workshop_categoy}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    id="email"
                                                                    label="Email Address"
                                                                    autoComplete="particent_email"
                                                                    name='particent_email'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.particent_email || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.particent_email || ""}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    label="Contact Number"
                                                                    type="text"
                                                                    name='particent_phone_number'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.particent_phone_number || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.particent_phone_number || ""}
                                                                />
                                                                <span style={{ color: 'red', textAlign: 'center' }}>
                                                                    If you don't have, just type 0000
                                                                </span>
                                                            </Grid>



                                                            <Grid item xs={6} >
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth

                                                                    label="Profession"
                                                                    autoFocus
                                                                    name='particent_profession'
                                                                    onChange={handleInput} value={editWorkShopParticpant?.particent_profession || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.particent_profession} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <FormControl>
                                                                    <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        value={gender.toString()}  // Convert the numeric value to a string
                                                                        onChange={handleChange}
                                                                    >
                                                                        <FormControlLabel value="0" control={<Radio />} label="Male" />
                                                                        <FormControlLabel value="1" control={<Radio />} label="Female" />
                                                                    </RadioGroup>
                                                                    <FormHelperText>{addWorkShopParticpant.error_list.participant_gender}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>


                                                            <Grid item xs={12} lg={6}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Country</InputLabel>
                                                                    <Select
                                                                        value={country || ""}
                                                                        onChange={handleCountry}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Action" >
                                                                        <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                                                                        <MenuItem value={'UAE'}>UAE</MenuItem>
                                                                        <MenuItem value={'Qatar'}> Qatar</MenuItem>
                                                                        <MenuItem value={'Oman'}>Oman </MenuItem>
                                                                        <MenuItem value={'Jordan'}>Jordan</MenuItem>
                                                                        <MenuItem value={'Trurky'}>Trurky </MenuItem>

                                                                    </Select>
                                                                    <FormHelperText></FormHelperText>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={6} >
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth
                                                                    label="City"
                                                                    autoFocus
                                                                    name='particent_city' onChange={handleInput} value={editWorkShopParticpant?.particent_city || ""} />
                                                            </Grid>
                                                        </Grid>


                                                        <Grid container justifyContent="space-between">
                                                            <Button
                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mt: 5 }}>
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                            </Button>
                                                        </Grid>

                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>

                                )}
                                {activeStep === 1 && (
                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                            
                                            <Card sx={{ width: '60vw', float: 'center' }} >
                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        WorkShop Registration
                                                    </Typography>
                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>

                                                            <Grid item xs={6}>
                                                                <FormControlLabel
                                                                    control={<Checkbox color="success" checked={singleWorkShopCategory.workshop_category_title !== null} />}
                                                                    label={
                                                                        <span
                                                                            sx={{
                                                                                margin: '55px',
                                                                                display: 'inline-block',
                                                                            }}
                                                                        >
                                                                            WorkShop Registration
                                                                        </span>
                                                                    }
                                                                    color="success"
                                                                    name="permissions"
                                                                />
                                                            </Grid>



                                                        </Grid>
                                                        <Grid container justifyContent="space-between">
                                                            <Button
                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mt: 5 }}>
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{ mt: 5, backgroundColor: backGroundButtonByEvent,}}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                            </Button>
                                                        </Grid>

                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                )}
                                {activeStep === 2 && (
                                    <div style={{ margin: '1%', width: '100%', }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                            
                                            <Card sx={{ width: '100%', float: 'center' }} >
                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        Registration Fees
                                                    </Typography>
                                                    <br></br>
                                                    <Typography
                                                        component="h6"
                                                        variant="h5"
                                                        sx={{
                                                            textAlign: 'center', // Center the text
                                                            color: 'red', // Set the text color to red
                                                        }} >
                                                        {addWorkShopParticpant.error_list.selectedWorkshopAmounts}
                                                    </Typography>


                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>

                                                            <Grid item xs={6} >

                                                            </Grid>

                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FormControlLabel
                                                                control={<Checkbox color="success" checked={singleWorkShopCategory.workshop_category_title !== null} />}
                                                                label={
                                                                    <span
                                                                        sx={{
                                                                            margin: '55px',
                                                                            display: 'inline-block',
                                                                        }}
                                                                    >
                                                                        {singleWorkShopCategory.workshop_category_title}
                                                                    </span>
                                                                }
                                                                color="success"
                                                                name="permissions"
                                                            />

                                                            <TableContainer component={Paper}>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>ID</TableCell>
                                                                            <TableCell>WorkShop Name</TableCell>
                                                                            <TableCell>WorkShop Day</TableCell>
                                                                            <TableCell>WokShopData</TableCell>
                                                                            <TableCell>WorkShop Start Time</TableCell>
                                                                            <TableCell>WorkShop End Time</TableCell>
                                                                            <TableCell>WorkShop Code</TableCell>
                                                                            <TableCell>Price</TableCell>
                                                                            <TableCell>Select</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {singleWorkShopCategory.work_shops &&
                                                                            singleWorkShopCategory.work_shops.map((row, i) => {
                                                                                const { isDisabled, color } = isCheckboxDisabled(row);
                                                                                return (
                                                                                    <TableRow key={row.id} style={{
                                                                                        backgroundColor: isCheckboxDisabled(row).color,
                                                                                    }}>
                                                                                        <TableCell>{i + 1}</TableCell>
                                                                                        <TableCell>{row.workshop_name}</TableCell>
                                                                                        <TableCell>{row.workshop_url}</TableCell>
                                                                                        <TableCell>{row.workshop_date}</TableCell>
                                                                                        <TableCell>{row.workshop_start_time}</TableCell>
                                                                                        <TableCell>{row.workshop_end_time}</TableCell>
                                                                                        <TableCell>{row.workshop_code}</TableCell>
                                                                                        <TableCell>{row.workshop_amount}</TableCell>
                                                                                        <TableCell>
                                                                                            <Checkbox
                                                                                                checked={editWorkShopParticpantWorkshops.some((selectedWorkshop) => selectedWorkshop.workshop_id === row.id)}
                                                                                                onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                disabled={isDisabled}
                                                                                                style={{ color: 'black', backgroundColor: 'white' }}
                                                                                            />

                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Grid>
                                                        <Grid container justifyContent="space-between">
                                                            <Button

                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mt: 5 }}>
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                            </Button>
                                                        </Grid>

                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                )}



                            </div>
                        )}
                    </div>
                </Grid>
            </Grid>
        </Container>
    )
}

export default EditWorkShopParticpant;
